import { JobFeeFieldNames } from 'constants/enums';

export const PRE_FILLED_FEES_FOR_JOB_CONFIGS = {
  [JobFeeFieldNames.OnboardingFee]: 1000,
  [JobFeeFieldNames.RetentionFee]: 2000,
  [JobFeeFieldNames.MonthlyAceFee]: 900,
  [JobFeeFieldNames.DirectHireFee]: 20,
  [JobFeeFieldNames.HourlyMarkupFee]: 1.5,
  [JobFeeFieldNames.FlatRateAmountFee]: 0
};

export const JOB_TYPES_SORT = [
  'FULL_TIME',
  'PART_TIME',
  'SEASONAL',
  'CONTRACTOR'
];

export const REMOTE_JOB_TYPE = 'REMOTE';

/**
 * @attention
 * Not Used!@
 */

export const DOMESTIC_OVERSEAS_SORT = [
  'Domestic',
  'International',
  'Domestic & International'
];

export const YEARS_IN_BUSINESS_SORT = ['1-3', '3-5', '5+', '10+'];
export const FREE_JOBS_AMOUNT = 3;
